const dashoboardMenu = [
  { key: "all", value: "All" },
  { key: "1", value: "Completed" },
  { key: "2", value: "Processing" },
  { key: "3", value: "Pending" },
  { key: "4", value: "Failed" },
  { key: "5", value: "Cancelled" },
];
const ftpChannelLanguage = [
  { key: "1", value: "All" },
  { key: "2", value: "Hindi" },
  { key: "3", value: "Bengali" },
  { key: "4", value: "Bhojpuri" },
  { key: "5", value: "Kannada" },
  { key: "6", value: "Malayalam" },
  { key: "7", value: "Marathi" },
  { key: "8", value: "Punjabi" },
  { key: "9", value: "Odia" },
  { key: "10", value: "Tamil" },
  { key: "11", value: "Telugu" },
];
const dashboardFilter = {
  all: "All",
  1: "Completed",
  2: "Processing",
  3: "Pending",
  4: "Failed",
  5: "Cancelled",
};

const aspect_ratio = [
  { key: "16:9", value: "16:9", coordinate: [0, 0, 100, 100] },
  {
    key: "1:1",
    value: "1:1",
    coordinate: [27.750000000000004, 10.102564102564097, 73.21153846153847, 90.92307692307693],
  },

  {
    key: "9:18",
    value: "9:18",
    coordinate: [37.69471153846155, 0, 63.266826923076934, 100],
  },

  // { key: "4:3", value: "4:3", coordinate: [20.173076923076927, 10.102564102564097, 80.78846153846155, 90.92307692307693] },
  {
    key: "3:4",
    value: "3:4",
    coordinate: [28.916666666666668, 0, 71.08333333333333, 100],
  },

  {
    key: "9:16",
    value: "9:16",
    coordinate: [37.69471153846155, 10.102564102564097, 63.266826923076934, 90.92307692307693],
  },

  {
    key: "4:5",
    value: "4:5",
    coordinate: [27.5, 0, 72.50000000000001, 100],
  },
];

const runObject = [
  {
    run: "1Run",
    runString: "One",
    key: "1",
  },
  {
    run: "2Runs",
    runString: "Two",
    key: "2",
  },
  {
    run: "3Runs",
    runString: "Three",
    key: "3",
  },
  {
    run: "4Runs",
    runString: "Four",
    key: "4",
  },
  {
    run: "6Runs",
    runString: "Six",
    key: "6",
  },
];

const playbackList = [
  {
    title: "1x",
    value: "1",
  },
  {
    title: "0.75x",
    value: "0.75",
  },
  {
    title: "0.5x",
    value: "0.5",
  },
];

const clipRating = [5, 4, 3, 2, 1];
const publishElement = [
  {
    title: "Published",
    value: "published",
  },
  {
    title: "Unpublished",
    value: "unpublished",
  },
  {
    title: "All",
    value: "",
  },
];

const socialMediaLabels = [
  {
    platform: "facebook",
    label: "Caption",
  },
  {
    platform: "instagram",
    label: "Caption",
  },
  {
    platform: "youtube",
    label: "Title",
  },
  {
    platform: "twitter",
    label: "Tweet",
  },
  {
    platform: "tiktok",
    label: "Title",
  },
];

const platformLimit = [
  {
    platform: "facebook",
    captionLimit: 63206,
    hashtagLimit: "No limit",
  },
  {
    platform: "instagram",
    captionLimit: 2200,
    hashtagLimit: "30 hashtags per caption",
  },
  {
    platform: "youtube",
    captionLimit: 100,
    hashtagLimit: "No limit",
  },
  {
    platform: "twitter",
    captionLimit: 280,
    hashtagLimit: "Hashtags are included in 280 character limit",
  },
];

const autoFlipCategories = [
  "football",
  "basketball",
  "tennis",
  "cricket",
  "American Football",
  "squash",
  "Baseball",
  "Softball",
  "entertainment",
  "zee_episode",
  "volleyball",
];

// const autoFlipCategories = ["entertainment", "zee_episode"];

const clientPermissions = [
  {
    label: "Add New Video",
    key: "addNewVideo",
    defaultValue: true,
    visibleTo: ["admin", "user"], // if superadmin give permission to Admin then admin also show this to his childs through this check
    accessLevels: ["superadmin", "user"], // which role can only see this
  },
  {
    label: "Export Clip JSON",
    key: "exportClipJSON",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"], // if superadmin give permission to Admin then admin also show this to his childs through this check
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Export DataFeed JSON",
    key: "exportDataFeedJSON",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Export Stream JSON",
    key: "exportStreamJSON",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Export Stream Clips XLSX",
    key: "exportStreamClipsXLSX",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Export Match Report",
    key: "exportMatchReport",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Download Clip Button",
    key: "downloadClipButton",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Download Highlight Button",
    key: "downloadHighlightButton",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "ScoreBoard Coordinate",
    key: "scoreBoardCoordinate",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Multiple Storage Path",
    key: "multipleStoragePath",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Reviewer Functionality",
    key: "reviewerFunctionality",
    defaultValue: false,
    visibleTo: ["admin"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Storage",
    key: "addStorages",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Settings",
    key: "showSettings",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Publish to CMS",
    key: "publishToCMS",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Upload to Brightcove",
    key: "uploadtoBrightcove",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Multi Folder Upload",
    key: "multiFolderUpload",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Show Clip TAT",
    key: "showClipTAT",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Web Story",
    key: "webStory",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Live editor/Web story addition",
    key: "liveEditor",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Add Storage Button",
    key: "addStorageButton",
    defaultValue: false,
    visibleTo: ["superadmin"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Social Media Share",
    key: "socialMediaPublish",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Auto Trigger Autoflip",
    key: "triggerAutoflip",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Clip Rating",
    key: "clipRating",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Vod",
    key: "vod",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Save V1",
    key: "livecutv2",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Export Folder JSON",
    key: "exportFolderJSON",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Export Events JSON",
    key: "exportEventsJSON",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "SFTP Upload",
    key: "uploadToSFTP",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "FTP Upload",
    key: "uploadToFTP",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Access Parent Storage",
    key: "accessParentStorage",
    defaultValue: false,
    visibleTo: ["user"],
    accessLevels: ["user"],
  },
  {
    label: "isAmplify User",
    key: "isAmplify",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin", "user"],
  },
  {
    label: "Restrict User Processing Limit",
    key: "restrictUserProcessingLimit",
    defaultValue: false,
    visibleTo: ["superadmin", "admin"],
    accessLevels: ["superadmin"],
  },
  {
    label: "Video Template",
    key: "outputVideoTemplate",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin"],
  },
  {
    label: "Amplify User",
    key: "isAmplify",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin", "user"],
  },
  {
    label: "Multi Audio",
    key: "multiAudio",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin", "user"],
  },
  {
    label: "Receive AI Clips & Enhanced Tagging",
    key: "allowEnhancedTagging",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin", "user"],
  },
  {
    label: "Is HLS to MP4",
    key: "isHlsToMp4",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Bumper exclusion from download limit",
    key: "bumperExclusionFromDownloadLimit",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin"],
  },
  {
    label: "Edit Video",
    key: "isEditVideo",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"], // if superadmin give permission to Admin then admin also show this to his childs through this check
    accessLevels: ["superadmin", "admin"], // which role can only see this
  },
  {
    label: "Delete Video",
    key: "isDeleteVideo",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"], // if superadmin give permission to Admin then admin also show this to his childs through this check
    accessLevels: ["superadmin", "admin"], // which role can only see this
  },
  {
    label: "View Video Details",
    key: "isViewVideoDetails",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"], // if superadmin give permission to Admin then admin also show this to his childs through this check
    accessLevels: ["superadmin", "admin"], // which role can only see this
  },
  {
    label: "Retrigger Video",
    key: "isRetriggerVideo",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"], // if superadmin give permission to Admin then admin also show this to his childs through this check
    accessLevels: ["superadmin", "admin"], // which role can only see this
  },
  {
    label: "Allow Access To Archive Videos Page",
    key: "isAllowAccessToArchiveVideos",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Clip Bulk Actions",
    key: "isClipBulkActions",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"], // if superadmin give permission to Admin then admin also show this to his childs through this check
    accessLevels: ["superadmin", "admin"], // which role can only see this
  },
  {
    label: "Copy Clip",
    key: "isCopyClip",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"], // if superadmin give permission to Admin then admin also show this to his childs through this check
    accessLevels: ["superadmin", "admin"], // which role can only see this
  },
  {
    label: "Upload To Cloud",
    key: "isUploadToCloud",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"], // if superadmin give permission to Admin then admin also show this to his childs through this check
    accessLevels: ["superadmin", "admin"], // which role can only see this
  },
  {
    label: "Bulk Clip Download",
    key: "isBulkClipDownload",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"], // if superadmin give permission to Admin then admin also show this to his childs through this check
    accessLevels: ["superadmin", "admin"], // which role can only see this
  },
  {
    label: "Upload Bulk Clips On Cloud",
    key: "isBulkClipUpload",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"], // if superadmin give permission to Admin then admin also show this to his childs through this check
    accessLevels: ["superadmin", "admin", "user"], // which role can only see this
  },
  {
    label: "Bulk Copy Clips",
    key: "isBulkCopyClip",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"], // if superadmin give permission to Admin then admin also show this to his childs through this check
    accessLevels: ["superadmin", "admin", "user"], // which role can only see this
  },
  {
    label: "Bulk Clip Delete",
    key: "isBulkClipDelete",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"], // if superadmin give permission to Admin then admin also show this to his childs through this check
    accessLevels: ["superadmin", "admin"], // which role can only see this
  },
  {
    label: "Clip Delete",
    key: "isClipDelete",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"], // if superadmin give permission to Admin then admin also show this to his childs through this check
    accessLevels: ["superadmin", "admin"], // which role can only see this
  },
  {
    label: "Upload Clips",
    key: "isUploadClips",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"], // if superadmin give permission to Admin then admin also show this to his childs through this check
    accessLevels: ["superadmin", "admin"], // which role can only see this
  },
  {
    label: "View Published Clips",
    key: "isViewPublishedClips",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Change Clip Thumbnail",
    key: "isChangeClipsThumbnail",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Static Cropper",
    key: "isStaticCropper",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Dynamic Cropper",
    key: "isDynamicCropper",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Generate Clip Title",
    key: "isGenerateClipTitle",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Allow Access To Clip Info Page",
    key: "isAllowAccessToClipInfo",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },

  {
    label: "Allow Access To Archive Clips Page",
    key: "isAllowAccessToArchiveClips",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Allow Access To Highlight Page",
    key: "isAllowAccessToHighlight",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Allow Access To Story Page",
    key: "isAllowAccessToStory",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Allow Access To Live Editor Page",
    key: "isAllowAccessToLiveEditor",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Enable Default List View",
    key: "isDefaultListView",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Allow auto rating",
    key: "allowAutoRating",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin", "user"],
  },
  {
    label: "Export usage report",
    key: "exportUsageReport",
    defaultValue: false,
    visibleTo: ["superadmin", "admin"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Advance Editor",
    key: "advanceEditor",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin", "user"],
  },
  {
    label: "Bulk Clip Editor",
    key: "isBulkClipEditor",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin", "user"],
  },
  {
    label: "Edit And Publish",
    key: "zeepublishing",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin", "user"],
  },
  {
    label: "Hide Right Click on Video Player",
    key: "isHideRightClick",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin", "user"],
  },
  {
    label: "Upload To 3rd Party S3",
    key: "isThirdPartyS3",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin", "user"],
  },
  {
    label: "Enable Stream Replay",
    key: "enableStreamReplay",
    defaultValue: false,
    visibleTo: ["admin", "user"], // if superadmin give permission to Admin then admin also show this to his childs through this check
    accessLevels: ["superadmin", "admin", "user"], // which role can only see this
  },
  {
    label: "Adobe Premier Plugin Account",
    key: "adobePremierPluginAccount",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin", "user"],
  },
  {
    label: "Export XML File",
    key: "exportXMP",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin", "user"],
  },
  {
    label: "Slack push notification(Highlight creations and Cut clips)",
    key: "slackPushNotification",
    defaultValue: false,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin"],
  },
  {
    label: "Quick Highlight",
    key: "quickHighlight",
    defaultValue: true,
    visibleTo: ["superadmin", "admin", "user"],
    accessLevels: ["superadmin", "admin", "user"],
  },
];

const months = [
  { month: "Jan", value: 1 },
  { month: "Feb", value: 2 },
  { month: "Mar", value: 3 },
  { month: "Apr", value: 4 },
  { month: "May", value: 5 },
  { month: "Jun", value: 6 },
  { month: "Jul", value: 7 },
  { month: "Aug", value: 8 },
  { month: "Sep", value: 9 },
  { month: "Oct", value: 10 },
  { month: "Nov", value: 11 },
  { month: "Dec", value: 12 },
];
const frequencyArr = [
  { name: "30 Sec", value: "30", key: 1 },
  { name: "5 Min", value: "300", key: 1 },
  { name: "10 Min", value: "600", key: 1 },
  { name: "20 Min", value: "1200", key: 2 },
  { name: "30 Min", value: "1800", key: 3 },
];
const steps = (path, id) => {
  let step = 1;
  switch (path) {
    case `/videos/${id}`:
      step = 1;
      break;
    case `/videos/${id}/graphics`:
      step = 3;
      break;
    case `/videos/${id}/sound`:
      step = 4;
      break;
    case `/videos/${id}/bumper`:
      step = 2;
      break;
    case `/videos/${id}/hashtag`:
      step = 5;
      break;
    default:
      break;
  }
  return step;
};

const editFields = {
  cricket: [
    {
      name: "batsman",
      key: "batsman",
      heading: "Batsman",
      type: "select",
      defaultValue: "clipData.batsman",
    },
    {
      name: "bowler",
      key: "bowler",
      heading: "Bowler",
      type: "select",
      defaultValue: "clipData.bowler",
    },
    {
      name: "over",
      key: "over",
      heading: "Over",
      type: "input",
      defaultValue: "clipData.over",
    },
    {
      name: "run",
      key: "run",
      heading: "Run",
      type: "input",
      defaultValue: "clipData.run",
    },
    {
      name: "wicket",
      key: "wicket",
      heading: "Wicket",
      type: "input",
      defaultValue: "clipData.wicket",
    },
    {
      name: "ballPosition",
      key: "ballPosition",
      heading: "Ball Position",
      type: "hardselect",
      defaultValue: "clipData.ballPosition",
      array: [
        "Fine Leg",
        "Square Leg",
        "Mid Wicket",
        "Long On",
        "Long Off",
        "Cover",
        "Mid Off",
        "Backward Short Leg",
        "Slip",
        "Silly point",
      ],
    },
    {
      name: "batsmanPosition",
      key: "batsmanPosition",
      heading: "Batsman Position",
      type: "hardselect",
      defaultValue: "clipData.batsmanPosition",
      array: ["Front Foot", "Back Foot"],
    },
    {
      name: "shotType",
      key: "shotType",
      heading: "Shot Type",
      type: "hardselect",
      defaultValue: "clipData.shotType",
      array: ["Cover Drive", "Flick", "Square Cut", "Pull", "Straight Drive", "Cut", "Scoop", "Sweep", "Reverse Sweep"],
    },
    {
      name: "wicketTerm",
      key: "wicketTerm",
      heading: "Wicket Term",
      type: "hardselect",
      defaultValue: "clipData.wicketTerm",
      array: ["Lbw", "Catch", "Bowled", "Run Out", "Hit Wicket", "Caught Behind", "Caught And Bowled"],
    },
  ],
  Cricket: [
    {
      name: "batsman",
      key: "batsman",
      heading: "Batsman",
      type: "select",
      defaultValue: "clipData.batsman",
    },
    {
      name: "bowler",
      key: "bowler",
      heading: "Bowler",
      type: "select",
      defaultValue: "clipData.bowler",
    },
    {
      name: "over",
      key: "over",
      heading: "Over",
      type: "input",
      defaultValue: "clipData.over",
    },
    {
      name: "run",
      key: "run",
      heading: "Run",
      type: "input",
      defaultValue: "clipData.run",
    },
    {
      name: "wicket",
      key: "wicket",
      heading: "Wicket",
      type: "input",
      defaultValue: "clipData.wicket",
    },
    {
      name: "ballPosition",
      key: "ballPosition",
      heading: "Ball Position",
      type: "hardselect",
      defaultValue: "clipData.ballPosition",
      array: [
        "Fine Leg",
        "Square Leg",
        "Mid Wicket",
        "Long On",
        "Long Off",
        "Cover",
        "Mid Off",
        "Backward Short Leg",
        "Slip",
        "Silly point",
      ],
    },
    {
      name: "batsmanPosition",
      key: "batsmanPosition",
      heading: "Batsman Position",
      type: "hardselect",
      defaultValue: "clipData.batsmanPosition",
      array: ["Front Foot", "Back Foot"],
    },
    {
      name: "shotType",
      key: "shotType",
      heading: "Shot Type",
      type: "hardselect",
      defaultValue: "clipData.shotType",
      array: ["Cover Drive", "Flick", "Square Cut", "Pull", "Straight Drive", "Cut", "Scoop", "Sweep", "Reverse Sweep"],
    },
    {
      name: "wicketTerm",
      key: "wicketTerm",
      heading: "Wicket Term",
      type: "hardselect",
      defaultValue: "clipData.wicketTerm",
      array: ["Lbw", "Catch", "Bowled", "Run Out", "Hit Wicket", "Caught Behind", "Caught And Bowled"],
    },
  ],
  filterBy: [
    { key: "all", value: "All" },
    { key: "fileName", value: "File Name" },
    { key: "status", value: "Status" },
    { key: "type", value: "Type" },
    { key: "channelName", value: "Channel Name" },
  ],
  settingUserMenu: [
    { key: "all", value: "All" },
    { key: "1", value: "Completed" },
    { key: "2", value: "Processing" },
    { key: "3", value: "Pending" },
    { key: "4", value: "Failed" },
    { key: "5", value: "Cancelled" },
  ],
  dashoboardMenu: [
    { key: "all", value: "All" },
    { key: "1", value: "Completed" },
    { key: "2", value: "Processing" },
    { key: "3", value: "Pending" },
    { key: "4", value: "Failed" },
    { key: "5", value: "Cancelled" },
  ],
  dashoboardMenuZee: [
    { key: "all", value: "All" },
    { key: "1", value: "Completed" },
    { key: "2", value: "Processing" },
    { key: "3", value: "Pending" },
    { key: "4", value: "Failed" },
    { key: "5", value: "Cancelled" },
  ],
  football: [
    {
      name: "batsman",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.batsman",
    },
    {
      name: "assist",
      key: "assist",
      heading: "Assist",
      type: "select",
      defaultValue: "clipData.assist",
    },
    {
      name: "referee",
      key: "referee",
      heading: "Referee",
      type: "select",
      defaultValue: "clipData.referee",
    },
  ],
  Football: [
    {
      name: "batsman",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.batsman",
    },
    {
      name: "assist",
      key: "assist",
      heading: "Assist",
      type: "select",
      defaultValue: "clipData.assist",
    },
    {
      name: "referee",
      key: "referee",
      heading: "Referee",
      type: "select",
      defaultValue: "clipData.referee",
    },
  ],
  hockey: [
    {
      name: "batsman",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.batsman",
    },
    {
      name: "assist",
      key: "assist",
      heading: "Assist",
      type: "select",
      defaultValue: "clipData.assist",
    },
  ],
  Hockey: [
    {
      name: "batsman",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.batsman",
    },
    {
      name: "assist",
      key: "assist",
      heading: "Assist",
      type: "select",
      defaultValue: "clipData.assist",
    },
  ],
  motorcycle_road_racing: [
    {
      name: "racer",
      key: "racer",
      heading: "Racer",
      type: "select",
      defaultValue: "clipData.racer",
    },
  ],
  "Motorcycle Road Racing": [
    {
      name: "racer",
      key: "racer",
      heading: "Racer",
      type: "select",
      defaultValue: "clipData.racer",
    },
  ],
  cornhole: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  Cornhole: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  a7fl: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  A7fl: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  american_7s_football: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  "American 7s Football": [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  Softball: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  softball: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  moto_gp: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  "Moto GP": [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  floorball: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  Floorball: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  volleyball: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  Volleyball: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  "American Football": [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  american_football: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  squash: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  Squash: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  "esports_-_pubg": [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  tennis: [
    {
      name: "player1",
      key: "player1",
      heading: "Player 1",
      type: "select",
      defaultValue: "clipData.player1",
    },
    {
      name: "player2",
      key: "player2",
      heading: "Player 2",
      type: "select",
      defaultValue: "clipData.player2",
    },
    {
      name: "point1",
      key: "player1_points",
      heading: "Set Point for Player 1",
      type: "hardselect",
      defaultValue: "clipData.point1",
      array: ["0", "1", "2", "3", "4", "5", "6", "7"],
    },
    {
      name: "point2",
      key: "player2_points",
      heading: "Set Point for Player 2",
      type: "hardselect",
      defaultValue: "clipData.point2",
      array: ["0", "1", "2", "3", "4", "5", "6", "7"],
    },
    {
      name: "matchPointPlayer1",
      key: "player1_match_points",
      heading: "Match Point for Player 1",
      type: "hardselect",
      defaultValue: "clipData.matchPointPlayer1",
      array: ["0", "15", "30", "40", "AD", "Game"],
    },
    {
      name: "matchPointPlayer2",
      key: "player2_match_points",
      heading: "Match Point for Player 2",
      type: "hardselect",
      defaultValue: "clipData.matchPointPlayer2",
      array: ["0", "15", "30", "40", "AD", "Game"],
    },
  ],
  Tennis: [
    {
      name: "player1",
      key: "player1",
      heading: "Player 1",
      type: "select",
      defaultValue: "clipData.player1",
    },
    {
      name: "player2",
      key: "player2",
      heading: "Player 2",
      type: "select",
      defaultValue: "clipData.player2",
    },
    {
      name: "point1",
      key: "player1_points",
      heading: "Set Point for Player 1",
      type: "hardselect",
      defaultValue: "clipData.point1",
      array: ["0", "1", "2", "3", "4", "5", "6", "7"],
    },
    {
      name: "point2",
      key: "player2_points",
      heading: "Set Point for Player 2",
      type: "hardselect",
      defaultValue: "clipData.point2",
      array: ["0", "1", "2", "3", "4", "5", "6", "7"],
    },
    {
      name: "matchPointPlayer1",
      key: "player1_match_points",
      heading: "Match Point for Player 1",
      type: "hardselect",
      defaultValue: "clipData.matchPointPlayer1",
      array: ["0", "15", "30", "40", "AD", "Game"],
    },
    {
      name: "matchPointPlayer2",
      key: "player2_match_points",
      heading: "Match Point for Player 2",
      type: "hardselect",
      defaultValue: "clipData.matchPointPlayer2",
      array: ["0", "15", "30", "40", "AD", "Game"],
    },
  ],
  basketball: [
    {
      name: "batsman",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.batsman",
    },
    {
      name: "assist",
      key: "assist",
      heading: "Assist",
      type: "select",
      defaultValue: "clipData.assist",
    },
  ],
  Basketball: [
    {
      name: "batsman",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.batsman",
    },
    {
      name: "assist",
      key: "assist",
      heading: "Assist",
      type: "select",
      defaultValue: "clipData.assist",
    },
  ],
  Baseball: [
    {
      name: "batsman",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.batsman",
    },
  ],
  baseball: [
    {
      name: "batsman",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.batsman",
    },
  ],
  pickleball: [
    {
      name: "batsman",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.batsman",
    },
  ],
  Pickleball: [
    {
      name: "batsman",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.batsman",
    },
  ],
  wrestling: [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
  ],
  Wrestling: [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
  ],
  ice_hockey: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
    {
      name: "assist",
      key: "assist",
      heading: "Assist",
      type: "select",
      defaultValue: "clipData.assist",
    },
    {
      name: "goalKeeper",
      key: "goalKeeper",
      heading: "Goal Keeper",
      type: "select",
      defaultValue: "clipData.goalKeeper",
    },
  ],
  "Ice Hockey": [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
    {
      name: "assist",
      key: "assist",
      heading: "Assist",
      type: "select",
      defaultValue: "clipData.assist",
    },
    {
      name: "goalKeeper",
      key: "goalKeeper",
      heading: "Goal Keeper",
      type: "select",
      defaultValue: "clipData.goalKeeper",
    },
  ],
  figure_skating: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  "Figure Skating": [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  speed_skating: [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
    {
      name: "player2",
      key: "player2",
      heading: "Player2",
      type: "select",
      defaultValue: "clipData.player2",
    },
  ],
  "Speed Skating": [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
    {
      name: "player2",
      key: "player2",
      heading: "Player2",
      type: "select",
      defaultValue: "clipData.player2",
    },
  ],
  bobsleigh: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  Bobsleigh: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  alpine_skiing: [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
    {
      name: "player2",
      key: "player2",
      heading: "Player2",
      type: "select",
      defaultValue: "clipData.player2",
    },
  ],
  "Alpine Skiing": [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
    {
      name: "player2",
      key: "player2",
      heading: "Player2",
      type: "select",
      defaultValue: "clipData.player2",
    },
  ],
  swimming: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  Swimming: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  f1: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  F1: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  Badminton: [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
    {
      name: "player2",
      key: "player2",
      heading: "Player2",
      type: "select",
      defaultValue: "clipData.player2",
    },
  ],
  badminton: [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
    {
      name: "player2",
      key: "player2",
      heading: "Player2",
      type: "select",
      defaultValue: "clipData.player2",
    },
  ],
  handball: [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
    {
      name: "player2",
      key: "player2",
      heading: "Player2",
      type: "select",
      defaultValue: "clipData.player2",
    },
  ],
  Handball: [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
    {
      name: "player2",
      key: "player2",
      heading: "Player2",
      type: "select",
      defaultValue: "clipData.player2",
    },
  ],
  "Table Tennis": [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
    {
      name: "player2",
      key: "player2",
      heading: "Player2",
      type: "select",
      defaultValue: "clipData.player2",
    },
  ],
  table_tennis: [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
    {
      name: "player2",
      key: "player2",
      heading: "Player2",
      type: "select",
      defaultValue: "clipData.player2",
    },
  ],
  Gaming: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  gaming: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  MMA: [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
  ],
  mma: [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
  ],
  "rugby league": [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
    {
      name: "player2",
      key: "player2",
      heading: "Player2",
      type: "select",
      defaultValue: "clipData.player2",
    },
  ],
  "rugby union": [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
    {
      name: "player2",
      key: "player2",
      heading: "Player2",
      type: "select",
      defaultValue: "clipData.player2",
    },
  ],
  golf: [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
  ],
  waterpolo: [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
  ],
  motogp: [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
  ],
  Lacrosse: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  lacrosse: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  AFL: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  afl: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  gymnastics: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  Gymnastics: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  Futsal: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  futsal: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  soccer: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  Soccer: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  australian_football: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  "Australian Football": [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  "Dirt Racing": [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
    {
      name: "player2",
      key: "player2",
      heading: "Player2",
      type: "select",
      defaultValue: "clipData.player2",
    },
  ],
  dirt_racing: [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
    {
      name: "player2",
      key: "player2",
      heading: "Player2",
      type: "select",
      defaultValue: "clipData.player2",
    },
  ],
  Athletics: [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
  ],
  athletics: [
    {
      name: "player1",
      key: "player1",
      heading: "Player1",
      type: "select",
      defaultValue: "clipData.player1",
    },
  ],
  netball: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  "Net Ball": [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  formula_1: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  "Formula 1": [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  formula_one: [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
  "Formula One": [
    {
      name: "player",
      key: "player",
      heading: "Player",
      type: "select",
      defaultValue: "clipData.player",
    },
  ],
};
const matchType = {
  cricket: [
    { name: "ODI", key: "ODI" },
    { name: "Test", key: "Test" },
    { name: "T10", key: "T10" },
    { name: "T20", key: "T20" },
    { name: "Hundred", key: "Hundred" },
    { name: "Sixty", key: "Sixty" },
    { name: "Other", key: "Other" },
  ],
};

const sportTags = {
  cricket: [
    { name: "Batsman", key: "batsman" },
    { name: "Bowler", key: "bowler" },
    { name: "Over", key: "over" },
    { name: "Run", key: "run" },
    { name: "Wicket", key: "wicket" },
  ],
  f1: [
    { name: "Pit Stops", key: "Pit Stops" },
    { name: "Yellow Flag", key: "Yellow Flag" },
    { name: "Red Flag", key: "Red Flag" },
    { name: "Safety Car", key: "Safety Car" },
    { name: "Overtake", key: "Overtake" },
    { name: "Radio Chats", key: "Radio Chats" },
    { name: "Replay", key: "Replay" },
  ],
  tennis: [
    { name: "Player1", key: "player1" },
    { name: "Player2", key: "player2" },
  ],
  boxing: [{ name: "Player1", key: "player1" }],
  football: [
    { name: "Score", key: "score" },
    { name: "Time", key: "time" },
    { name: "Team1", key: "team1" },
    { name: "Team2", key: "team2" },
  ],
  basketball: [
    { name: "Score", key: "score" },
    { name: "Time", key: "time" },
    { name: "Team1", key: "team1" },
    { name: "Team2", key: "team2" },
    { name: "Game Clock", key: "game_clock" },
    { name: "Quarter", key: "quarter" },
  ],
  Basketball: [
    { name: "Score", key: "score" },
    { name: "Time", key: "time" },
    { name: "Team1", key: "team1" },
    { name: "Team2", key: "team2" },
    { name: "Game Clock", key: "game_clock" },
    { name: "Quarter", key: "quarter" },
  ],
  handball: [
    { name: "Score", key: "score" },
    { name: "Time", key: "time" },
    { name: "Team1", key: "team1" },
    { name: "Team2", key: "team2" },
  ],
  Handball: [
    { name: "Score", key: "score" },
    { name: "Time", key: "time" },
    { name: "Team1", key: "team1" },
    { name: "Team2", key: "team2" },
  ],
  futsal: [
    { name: "Score", key: "score" },
    { name: "Time", key: "time" },
    { name: "Team1", key: "team1" },
    { name: "Team2", key: "team2" },
  ],
};

const languageArr = [
  {
    name: "Hi",
    value: "hi",
  },
  {
    name: "En",
    value: "en",
  },
  {
    name: "Ta",
    value: "ta",
  },
];
const aspectRatio = [
  { aspect_ratio: "9:16", value: "9/16" },
  { aspect_ratio: "9:18", value: "9/18" },
  { aspect_ratio: "3:4", value: "3/4" },
  { aspect_ratio: "1:1", value: "1/1" },
  //{ aspect_ratio: "16:9", value: "16/9" },
  // { aspect_ratio: "4:3", value: "4/3" },
  //{ aspect_ratio: "21:9", value: "21/9" },
  { aspect_ratio: "4:5", value: "4/5" },
];

const aspectRatioVal = {
  //ratio of aspect-ratio
  "16:9": 1.77,
  "4:3": 1.33,
  "1:1": 1.0,
  "9:16": 0.56,
  "4:5": 0.8,
  "9:18": 0.5,
  "3:4": 0.75,
};

const tagValues = [
  "batsman",
  "bowler",
  "player1",
  "player2",
  "player",
  "fielder",
  "assist",
  "racer",
  "goalKeeper",
  "referee",
  "outcome",
  "shotType",
  "gameTime",
  "heartbeat",
];

const numberFormat = (num) => {
  return num.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 });
};

const settingsRecordsPerPage = 20;

const cookieExpiry = { expires: 180, secure: true };

const storyInputFields = [
  { name: "story_title", heading: "Title", type: "text", placeholder: "", defaultValue: "Test Story" },
  { name: "url", heading: "Video Url", type: "text", placeholder: "", defaultValue: "" },
  { name: "matchLink", heading: "Webstory Redirect Link", type: "text", placeholder: "", defaultValue: "" },
  { name: "publisher", heading: "Publisher", type: "text", placeholder: "", defaultValue: "" },
  { name: "analytics_ids", heading: "Analytics Ids", type: "text", placeholder: "ID_1, ID_2, ID_3", defaultValue: "" },
  { name: "publisherLogoUrl", heading: "Publisher Logo Url", type: "text", placeholder: "", defaultValue: "" },
  { name: "portraitPosterUrl", heading: "Portrait Poster Url", type: "text", placeholder: "", defaultValue: "" },
  { name: "canonicalUrl", heading: "Canonical Url", type: "text", placeholder: "", defaultValue: "" },
  { name: "favicons", heading: "Favicons Url", type: "text", placeholder: "", defaultValue: "" },
  { name: "no_of_pages", heading: "Number Of Pages", type: "number", placeholder: "", defaultValue: "2" },
];
const sonyClientPublishField = [
  {
    name: "description",
    heading: "Description",
    type: "text",
    placeholder: "",
    defaultValue: "description",
    defaultValueFrom: "stream",
  },
  {
    name: "competitionId",
    heading: "Competition Id",
    type: "text",
    placeholder: "",
    defaultValue: "competitionId",
    defaultValueFrom: "stream",
  },
  {
    name: "tags",
    heading: "Tags",
    type: "text",
    placeholder: "",
    defaultValue: "tags",
    defaultValueFrom: "stream",
  },
  {
    name: "seoTitle",
    heading: "SEO Title",
    type: "text",
    placeholder: "",
    defaultValue: "seoObject.seoTitle",
    defaultValueFrom: "stream",
  },
  {
    name: "seoDescription",
    heading: "SEO Description",
    type: "text",
    placeholder: "",
    defaultValue: "seoObject.seoDescription",
    defaultValueFrom: "stream",
  },
  {
    name: "objectSubtype",
    heading: "Clip Type",
    type: "dropdown",
    placeholder: "",
    defaultValue: "objectSubtype",
    defaultValueFrom: "stream",
    options: [
      {
        label: "SPORTS_CLIPS",
        value: "SPORTS_CLIPS",
      },
      {
        label: "HIGHLIGHTS",
        value: "HIGHLIGHTS",
      },
    ],
  },
];

const shotType = [
  { name: "None", value: "none" },
  { name: "Jump Shot", value: "jump_shot" },
  { name: "Hook Shot", value: "hook_shot" },
  { name: "Bank Shot", value: "bank_shot" },
  { name: "Free Throw", value: "free_throw" },
  { name: "Layup", value: "layup" },
  { name: "Slam Dunk", value: "slam_dunk" },
  { name: "Tip In", value: "tip_in" },
];

const heartbeat = [
  { name: "None", value: "none" },
  { name: "Tip-off", value: "tipoff" },
  { name: "Crowd reaction", value: "crowdreaction" },
  { name: "Winning shot", value: "winningshot" },
  { name: "Buzzer beater", value: "buzzerbeater" },
];

const gameTime = [
  { name: "Quarter 01", value: "quarter01" },
  { name: "Quarter 02", value: "quarter02" },
  { name: "Quarter 03", value: "quarter03" },
  { name: "Quarter 04", value: "quarter04" },
];

const audios = [
  { name: "Mp3", value: "mp3" },
  { name: "Mpeg", value: "mpeg" },
];
const aspectRatioClip = [
  { name: "All", value: "" },
  { name: "16:9", value: "16:9" },
  { name: "9:16", value: "9:16" },
  { name: "9:18", value: "9:18" },
  { name: "3:4", value: "3:4" },
  // { name: "4:3", value: "4:3" },
  { name: "1:1", value: "1:1" },
  { name: "4:5", value: "4:5" },
];
const graphics = [
  { name: "Png", value: "png" },
  { name: "Jpg", value: "jpg" },
  { name: "Jpeg", value: "jpeg" },
];
const bumpers = [
  { name: "Mp4", value: "mp4" },
  { name: "Webm", value: "webm" },
];
const playBackSpeed = [
  { value: "0.5", name: "0.5x" },
  { value: "0.75", name: "0.75x" },
  { value: "1", name: "1x" },
  { value: "all", name: "All" },
];
const deviceArray = [
  { value: "649,360", name: "Samsung S22" },
  { value: "786,393", name: "Samsung S23" },
  { value: "670,360", name: "Samsung S21" },
  { value: "722,412", name: "Samsung S10" },
  { value: "612,308", name: "Samsung S8" },
  { value: "718,412", name: "Samsung Galaxy Note 8" },
  { value: "736,432", name: "Google Pixel 3a XL" },
  { value: "727,393", name: "Google Pixel 4" },
  { value: "797,412", name: "Moto G71 5G" },
  { value: "616,360", name: "Moto G7 Play" },
  { value: "713,384", name: "Oneplus 9" },
  { value: "757,412", name: "Oneplus 6T" },
  { value: "736,393", name: "Redmi Note 11" },
  { value: "719,393", name: "Redmi Note 8" },
  { value: "724,384", name: "Vivo Y21" },
  { value: "665,360", name: "Oppo A96" },
  { value: "657,360", name: "Huawei P30" },
  { value: "664,360", name: "Realme 8" },
  { value: "664,390", name: "iPhone 12" },
  { value: "629,375", name: "iPhone 12 mini" },
  { value: "746,428", name: "iPhone 13 Pro Max" },
  { value: "786,393", name: "iPhone 14 Pro Max" },
  { value: "1080,810", name: "iPad 10th" },
  { value: "954,768", name: "iPad 6th" },
  { value: "1010,810", name: "iPad 8th" },
];

const entertainment_fields = [
  { key: "Summary", value: "summary" },
  { key: "Webisode", value: "webisode" },
  { key: "Best Scene", value: "best_scene" },
];

const playbackLabels = [
  {
    title: "0.25x",
    value: "0.25",
  },
  {
    title: "0.5x",
    value: "0.5",
  },
  {
    title: "1x",
    value: "1",
  },
  {
    title: "1.25x",
    value: "1.25",
  },
  {
    title: "1.5x",
    value: "1.50",
  },
  {
    title: "2x",
    value: "2",
  },
];

const allowAspectRatio = [
  { key: "16:9", value: "16:9", allowedRatio: ["16:9"] },
  { key: "9:18", value: "9:18", allowedRatio: ["9:18", "16:9"] },
  { key: "3:4", value: "3:4", allowedRatio: ["3:4", "16:9"] },
  {
    key: "1:1",
    value: "1:1",
    allowedRatio: ["16:9", "1:1"],
  },
  // { key: "4:3", value: "4:3", allowedRatio: ["16:9", "4:3"] },
  {
    key: "9:16",
    value: "9:16",
    allowedRatio: ["16:9", "9:16"],
  },
  {
    key: "4:5",
    value: "4:5",
    allowedRatio: ["16:9", "4:5"],
  },
];
const options = [
  { value: -1, label: "NR" },
  { value: 1, label: "1 star" },
  { value: 2, label: "2 star" },
  { value: 3, label: "3 star" },
  { value: 4, label: "4 star" },
  { value: 5, label: "5 star" },
];
const staticDimension = { width: 900, height: 506.25 };
const downloadTemplates = {
  s3Glacier: "https://d7xz21f54epr.cloudfront.net/3tBwdNb9s/csv/export_csv_streamId.csv",
};
const downloadTemplatesYoutube = {
  youTubeVideoCSV: "https://d7xz21f54epr.cloudfront.net/3tBwdNb9s/csv/export_youtube_csv.csv",
};

const awsRegions = [
  { label: "US East (N. Virginia)", value: "us-east-1" },
  { label: "US East (Ohio)", value: "us-east-2" },
  { label: "US West (N. California)", value: "us-west-1" },
  { label: "US West (Oregon)", value: "us-west-2" },
  { label: "AWS GovCloud (US)", value: "us-gov-west-1" },
  { label: "AWS GovCloud (US-East)", value: "us-gov-east-1" },
  { label: "Canada (Central)", value: "ca-central-1" },
  { label: "EU (Stockholm)", value: "eu-north-1" },
  { label: "EU (Ireland)", value: "eu-west-1" },
  { label: "EU (London)", value: "eu-west-2" },
  { label: "EU (Paris)", value: "eu-west-3" },
  { label: "EU (Frankfurt)", value: "eu-central-1" },
  { label: "EU (Milan)", value: "eu-south-1" },
  { label: "Africa (Cape Town)", value: "af-south-1" },
  { label: "Asia Pacific (Tokyo)", value: "ap-northeast-1" },
  { label: "Asia Pacific (Seoul)", value: "ap-northeast-2" },
  { label: "Asia Pacific (Osaka-Local)", value: "ap-northeast-3" },
  { label: "Asia Pacific (Singapore)", value: "ap-southeast-1" },
  { label: "Asia Pacific (Sydney)", value: "ap-southeast-2" },
  { label: "Asia Pacific (Jakarta)", value: "ap-southeast-3" },
  { label: "Asia Pacific (Hong Kong)", value: "ap-east-1" },
  { label: "Asia Pacific (Mumbai)", value: "ap-south-1" },
  { label: "South America (São Paulo)", value: "sa-east-1" },
  { label: "Middle East (Bahrain)", value: "me-south-1" },
  { label: "China (Beijing)", value: "cn-north-1" },
  { label: "China (Ningxia)", value: "cn-northwest-1" },
  { value: "me-central-1", label: "Middle East(UAE)" },
];

const awsRegionsWithValues = [
  { label: "us-east-1", value: "us-east-1" },
  { label: "us-east-2", value: "us-east-2" },
  { label: "us-west-1", value: "us-west-1" },
  { label: "us-west-2", value: "us-west-2" },
  { label: "us-gov-west-1", value: "us-gov-west-1" },
  { label: "us-gov-east-1", value: "us-gov-east-1" },
  { label: "ca-central-1", value: "ca-central-1" },
  { label: "eu-north-1", value: "eu-north-1" },
  { label: "eu-west-1", value: "eu-west-1" },
  { label: "eu-west-2", value: "eu-west-2" },
  { label: "eu-west-3", value: "eu-west-3" },
  { label: "eu-central-1", value: "eu-central-1" },
  { label: "eu-south-1", value: "eu-south-1" },
  { label: "af-south-1", value: "af-south-1" },
  { label: "ap-northeast-1", value: "ap-northeast-1" },
  { label: "ap-northeast-2", value: "ap-northeast-2" },
  { label: "ap-northeast-3", value: "ap-northeast-3" },
  { label: "ap-southeast-1", value: "ap-southeast-1" },
  { label: "ap-southeast-2", value: "ap-southeast-2" },
  { label: "ap-southeast-3", value: "ap-southeast-3" },
  { label: "ap-east-1", value: "ap-east-1" },
  { label: "ap-south-1", value: "ap-south-1" },
  { label: "sa-east-1", value: "sa-east-1" },
  { label: "me-south-1", value: "me-south-1" },
  { label: "cn-north-1", value: "cn-north-1" },
  { label: "cn-northwest-1", value: "cn-northwest-1" },
  { value: "me-central-1", label: "me-central-1" },
];

const mediaLiveInput = [
  { label: "URL PULL", value: "URL_PULL" },
  { label: "SRT PULL", value: "SRT_PULL" },
  { label: "RTMP PUSH", value: "RTMP_PUSH" },
  { label: "RTMP PULL", value: "RTMP_PULL" },
  { label: "MP4 FILE", value: "MP4_FILE" },
  { label: "SRT_PUSH", value: "SRT_PUSH" },
  { label: "ZIXI_PUSH", value: "ZIXI_PUSH" },
];
const mediaStaticInput = [
  { label: "URL PULL", value: "URL_PULL" },
  { label: "MKV FILE", value: "MKV_FILE" },
  { label: "MOV FILE", value: "MOV_FILE" },
  { label: "WEBM FILE", value: "WEBM_FILE" },
  { label: "MP4 FILE", value: "MP4_FILE" },
  { label: "MXF FILE", value: "MXF_FILE" },
];

const MEDIA_STATIC_INPUT_TYPE = {
  URL_PULL: "URL_PULL",
  MKV_FILE: "MKV_FILE",
  MOV_FILE: "MOV_FILE",
  WEBM_FILE: "WEBM_FILE",
  MP4_FILE: "MP4_FILE",
  MXF_FILE: "MXF_FILE",
};

const streamingType = [
  { label: "LIVE TO VOD", value: "live_to_vod" },
  { label: "VOD TO VOD", value: "vod_to_vod" },
];
const bitRateModes = [
  { label: "CBR", value: "CBR" },
  { label: "VBR", value: "VBR" },
  { label: "QVBR", value: "QVBR" },
];
const mediaLiveTemplateOption = [
  { value: "direct", label: "Direct" },
  { value: "medialive", label: "Media live" },
  { value: "reserved_channel", label: "Reserved Channel" },
];
const mediaLiveTemplateRegions = [
  { value: "asia", label: "Asia" },
  { value: "north america", label: "North America" },
  { value: "europe", label: "Europe" },
  { value: "south america", label: "South America" },
  { value: "africa", label: "Africa" },
  { value: "middle-east(uae)", label: "Middle East(UAE)" },
];

const fpsModes = [
  { label: "Static", value: "static" },
  { label: "Dynamic", value: "dynamic" },
];

const fileTypes = [
  { label: "Static", value: "static" },
  { label: "Live", value: "live" },
];

const fillMultiAudioWithStreamOptions = [
  { label: "Audio selection", value: "false" },
  { label: "Audio selection during stream add", value: "true" },
];

const dolbyAudio51RemixOptions = [
  { label: "Dolby Audio 5.1 selection during stream add", value: "true" },
  { label: "Set Dolby Audio 5.1 default for template", value: "false" },
];
const audioOptions = [
  { label: "ISO", value: "iso" },
  { label: "PID", value: "pid" },
  { label: "TRACK", value: "track" },
];

const gameTimeBasketBall = [
  { label: "Quarter 01", value: "quarter01" },
  { label: "Quarter 02", value: "quarter02" },
  { label: "Quarter 03", value: "quarter03" },
  { label: "Quarter 04", value: "quarter04" },
];

const acceptedFilesSize = 400 * 1024 * 1024;

export const clipFeedbackOption = [
  { key: "Early", value: "early" },
  { key: "Late", value: "late" },
  { key: "Correct", value: "correct" },
];
export const ruleRatingConfig = [
  {
    fields: [
      {
        label: "Rule name",
        type: "TEXT",
        name: "ruleName",
        value: "",
        suggestions: [],
      },
      {
        label: "Events",
        type: "SELECT",
        name: "events",
        value: "",
        multiple: true,
        suggestions: ["Four", "Six", "Wicket"],
      },
      {
        label: "Match Type",
        type: "TAB",
        name: "matchType",
        suggestions: ["ODI", "T20", "Test"],
        value: "",
      },
      // {
      //   label: "Four",
      //   type: "subFields",
      //   suggestions: [],
      //   fields: [
      //     {
      //       label: "Over from",
      //       type: "TEXT",
      //       name: "overFrom",
      //       value: "",
      //       suggestions: [],
      //     },
      //     {
      //       label: "Over to",
      //       name: "overTo",
      //       type: "TEXT",
      //       value: "",
      //       suggestions: [],
      //     },
      //     {
      //       label: "Rating",
      //       type: "SELECT",
      //       name: "rating",
      //       value: "",
      //       suggestions: [1, 2, 3, 4, 5],
      //     },
      //   ],
      // },
    ],
  },
];

export const socialMediaProfiles = [
  {
    platform: "facebook",
    label: "Facebook",
    icon: "components/v2/Modal/facebook.svg",
  },
  {
    platform: "instagram",
    label: "Instagram",
    icon: "components/v2/Modal/instagram.svg",
  },
  {
    platform: "linkedin",
    label: "Linkedin",
    icon: "components/v2/Modal/linkedin.svg",
  },
  {
    platform: "twitter",
    label: "X",
    icon: "components/v2/Modal/x.svg",
  },
  {
    platform: "youtube",
    label: "Youtube",
    icon: "components/v2/Modal/youtube.svg",
  },
  {
    platform: "tiktok",
    label: "Tiktok",
    icon: "components/v2/Modal/tiktok.svg",
  },
  {
    platform: "telegram",
    label: "Telegram",
    icon: "components/v2/Modal/telegram.svg",
  },
];

export const studioPublishSocialMediaProfiles = [
  {
    value: "facebook",
    label: "Facebook",
    icon: "containers/studio-publish/facebook-publish.svg",
  },
  {
    value: "instagram",
    label: "Instagram",
    icon: "containers/studio-publish/instagram-publish.svg",
  },
  {
    value: "twitter",
    label: "X",
    icon: "containers/studio-publish/twitter-publish.svg",
  },
  {
    value: "linkedin",
    label: "Linkedin",
    icon: "containers/studio-publish/linkedin-publish.svg",
  },

  {
    value: "youtube",
    label: "Youtube",
    icon: "containers/studio-publish/youtube-publish.svg",
  },
  {
    value: "tiktok",
    label: "Tiktok",
    icon: "containers/studio-publish/tiktok-publish.svg",
  },
  {
    value: "telegram",
    label: "Telegram",
    icon: "containers/studio-publish/telegram-publish.svg",
  },
];

export const illustoClipType = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Clips",
    value: "clip",
  },
  {
    label: "Highlights",
    value: "highlight",
  },
];

const aspectRatios = [
  {
    name: "16:9",
    value: "16/9",
  },
  {
    name: "9:16",
    value: "9/16",
  },
  {
    name: "9:18",
    value: "9/18",
  },
  {
    name: "3:4",
    value: "3/4",
  },
  // { name: "4:3", value: "4/3" },
  {
    name: "4:5",
    value: "4/5",
  },
  {
    name: "1:1",
    value: "1/1",
  },
];

const timelineZoomValues = {
  0: 600,
  10: 420,
  20: 300,
  30: 200,
  40: 150,
  50: 30,
  60: 25,
  70: 20,
  80: 15,
  90: 10,
  100: 5,
};

const streamPointerItems = [
  {
    type: "datafeed-genius-pointer-start",
    name: "Genius Datafeed Start",
  },
  {
    type: "custom-marker",
    name: "Custom marker",
  },
  {
    type: "datafeed-genius-pointer-end",
    name: "Genius Datafeed End",
  },
  {
    type: "datafeed-marker",
    name: "Datafeed markers",
  },
  {
    type: "internal-datafeed-marker",
    name: "Internal Datafeed markers",
  },
  {
    type: "SCOREBOARD_OCR",
    name: "Internal Feed",
  },
  {
    type: "delay-pointer",
    name: "Delay Marker",
  },
];

const streamPointerSourceLabels = {
  "datafeed-marker": "Datafeed",
  "internal-datafeed-marker": "Internal datafeed",
  SCOREBOARD_OCR: "Internal Feed",
  "datafeed-genius-pointer-end": "Genius Datafeed End",
  "custom-marker": "Custom Marker",
  "delay-pointer": "Delay Marker",
  "datafeed-genius-pointer-start": "Genius Datafeed Start",
};

const streamPointerSource = {
  DATAFEED_MARKER: "datafeed-marker",
  INTERNAL_DATAFEED_MARKER: "internal-datafeed-marker",
  DATAFEED_GENIUS_POINTER_START: "datafeed-genius-pointer-start",
  SCOREBOARD_OCR: "SCOREBOARD_OCR",
  CUSTOM_MARKER: "custom-marker",
  DATAFEED_GENIUS_POINTER_END: "datafeed-genius-pointer-end",
  DELAY_POINTER: "delay-pointer",
};

const streamPointerDeleteableTypes = [
  streamPointerSource.CUSTOM_MARKER,
  streamPointerSource.DELAY_POINTER,
  streamPointerSource.DATAFEED_GENIUS_POINTER_START,
  streamPointerSource.DATAFEED_GENIUS_POINTER_END,
];

const streamPointerEditableTypes = [streamPointerSource.DELAY_POINTER];

const datafeedPointerCategories = [
  "football",
  "volleyball",
  "ice_hockey",
  "handball",
  "tennis",
  "basketball",
  "American Football",
  "korfball",
  "golf",
];

const scoreboardOcrEventItems = {
  football: [
    { name: "Game Start", value: "game start", color: "#ff3b30" },
    { name: "Game End", value: "game end", color: "#ff3b30" },
    { name: "First Half End", value: "first half end", color: "#ff3b30" },
    { name: "Second Half Start", value: "second half start", color: "#ff3b30" },
  ],
};

export const streamPointerEventItems = {
  football: {
    genius: [
      { name: "Goal", value: "goal", color: "#36B05F" },
      { name: "Save", value: "save", color: "#D636BE" },
      { name: "Card Yellow", value: "cardyellow", color: "#DEA742" },
      { name: "Assist", value: "assist", color: "#DEA742" },
      { name: "Throw in", value: "throwin", color: "#DEA742" },
      { name: "Card Red", value: "cardred", color: "#E64141" },
      { name: "Foul", value: "foul", color: "#E64141" },
      { name: "Offside", value: "offside", color: "#E64141" },
      { name: "Injury", value: "injury", color: "#E64141" },
      { name: "Corner", value: "corner", color: "#429ADE" },
      { name: "Substitution", value: "substitution", color: "#429ADE" },
      { name: "Shot", value: "shot", color: "#429ADE" },
      { name: "Penalty Kick", value: "penaltykick", color: "#429ADE" },
      { name: "Free Kick", value: "freekick", color: "#429ADE" },
      { name: "Period", value: "period", color: "#ff3b30" },
      { name: "Kickoff", value: "kickoff", color: "#ff3b30" },
      { name: "Shootout Kick", value: "shootoutkick", color: "#ff3b30" },
      { name: "Shootout Save", value: "shootoutsave", color: "#D636BE" },
    ],
    statsPerform: [
      { name: "Pass", value: "pass", color: "#DEA742" },
      { name: "Offside Pass", value: "offsidepass", color: "#DEA742" },
      { name: "Take On", value: "takeon", color: "#DEA742" },
      { name: "Foul", value: "foul", color: "#E64141" },
      { name: "Out", value: "out", color: "#E64141" },
      { name: "Corner Awarded", value: "cornerawarded", color: "#429ADE" },
      { name: "Tackle", value: "tackle", color: "#DEA742" },
      { name: "Interception", value: "interception", color: "#3636D6" },
      { name: "Save", value: "save", color: "#D636BE" },
      { name: "Claim", value: "claim", color: "#DEA742" },
      { name: "Clearance", value: "clearance", color: "#429ADE" },
      { name: "Miss", value: "miss", color: "#E64141" },
      { name: "Post", value: "post", color: "#429ADE" },
      { name: "Attempt Saved", value: "attemptsaved", color: "#D636BE" },
      { name: "Goal", value: "goal", color: "#36B05F" },
      { name: "Card", value: "card", color: "#E64141" },
      { name: "Player off", value: "playeroff", color: "#E64141" },
      { name: "Player on", value: "playeron", color: "#429ADE" },
      { name: "Player retired", value: "playerretired", color: "#E64141" },
      { name: "Player returns", value: "playerreturns", color: "#429ADE" },
      { name: "Player becomes goalkeeper", value: "playerbecomesgoalkeeper", color: "#429ADE" },
      { name: "Goalkeeper becomes player", value: "goalkeeperbecomesplayer", color: "#429ADE" },
      { name: "Condition change", value: "conditionchange", color: "#429ADE" },
      { name: "Official change", value: "officialchange", color: "#3636D6" },
      { name: "Start delay", value: "startdelay", color: "#ff3b30" },
      { name: "End delay", value: "enddelay", color: "#ff3b30" },
      { name: "Temporary stop", value: "temporarystop", color: "#ff3b30" },
      { name: "End", value: "end", color: "#E64141" },
      { name: "Picked an orange", value: "pickedanorange", color: "#EB5A2D" },
      { name: "Start", value: "start", color: "#ff3b30" },
      { name: "Team set up", value: "teamsetup", color: "#ff3b30" },
      { name: "Player changed Jersey number", value: "playerchangedjerseynumber", color: "#ff3b30" },
      { name: "Collection End", value: "collectionend", color: "#3636D6" },
      { name: "Temp Goal", value: "tempgoal", color: "#36B05F" },
      { name: "Temp Attempt", value: "tempattempt", color: "#DEA742" },
      { name: "Formation change", value: "formationchange", color: "#ff3b30" },
      { name: "Punch", value: "punch", color: "#D636BE" },
      { name: "Good skill", value: "goodskill", color: "#3636D6" },
      { name: "Deleted event", value: "deletedevent", color: "#E64141" },
      { name: "Aerial", value: "aerial", color: "#3636D6" },
      { name: "Challenge", value: "challenge", color: "#3636D6" },
      { name: "Postponed", value: "postponed", color: "#ff3b30" },
      { name: "Rescinded card", value: "rescindedcard", color: "#ff3b30" },
      { name: "Ball recovery", value: "ballrecovery", color: "#3636D6" },
      { name: "Dispossessed", value: "dispossessed", color: "#3636D6" },
      { name: "Error", value: "error", color: "#E64141" },
      { name: "Keeper pick-up", value: "keeperpickup", color: "#DEA742" },
      { name: "Cross not claimed", value: "crossnotclaimed", color: "#3636D6" },
      { name: "Smother", value: "smother", color: "#DEA742" },
      { name: "Offside provoked", value: "offsideprovoked", color: "#E64141" },
      { name: "Shield ball opp", value: "shieldballopp", color: "#3636D6" },
      { name: "Foul throw-in", value: "foultrowin", color: "#E64141" },
      { name: "Penalty faced", value: "penaltyfaced", color: "#429ADE" },
      { name: "Keeper Sweeper", value: "keepersweeper", color: "#DEA742" },
      { name: "Chance missed", value: "chancemissed", color: "#E64141" },
      { name: "Ball touch", value: "balltouch", color: "#3636D6" },
      { name: "Event placeholder", value: "eventplaceholder", color: "#3636D6" },
      { name: "Temp Save", value: "tempsave", color: "#D636BE" },
      { name: "Resume", value: "resume", color: "#ff3b30" },
      { name: "Contentious referee decision", value: "contentiousrefereedecision", color: "#ff3b30" },
      { name: "Possession Data", value: "possessiondata", color: "#3636D6" },
      { name: "50/50", value: "50/50", color: "#3636D6" },
      { name: "Referee Drop Ball", value: "refereedropball", color: "#ff3b30" },
      { name: "Failed to Block", value: "failedtoblock", color: "#3636D6" },
      { name: "Injury Time Announcement", value: "injurytimeannouncement", color: "#E64141" },
      { name: "Coach Setup", value: "coachsetup", color: "#ff3b30" },
      { name: "Caught Offside", value: "caughtoffside", color: "#E64141" },
      { name: "Other Ball Contact", value: "otherballcontact", color: "#3636D6" },
      { name: "Blocked Pass", value: "blockedpass", color: "#DEA742" },
      { name: "Delayed start", value: "delayedstart", color: "#ff3b30" },
      { name: "Early end", value: "earlyend", color: "#ff3b30" },
      { name: "Temp card", value: "tempcard", color: "#3636D6" },
      { name: "Coverage interruption", value: "coverageinterruption", color: "#E64141" },
      { name: "Drop of Ball", value: "dropofball", color: "#ff3b30" },
      { name: "Obstacle", value: "obstacle", color: "#3636D6" },
      { name: "Control", value: "control", color: "#429ADE" },
      { name: "Attempted tackle", value: "attemptedtackle", color: "#DEA742" },
      { name: "Deleted After Review", value: "deletedafterreview", color: "#E64141" },
    ],
    tv2: [
      { name: "Full Time", value: "full_time", color: "#ff3b30" },
      { name: "Yellow Card", value: "yellow_card", color: "#DEA742" },
      { name: "Substitution In", value: "substitution_in", color: "#429ADE" },
      { name: "Second Half Extra Time", value: "second_half_extra_time", color: "#ff3b30" },
      { name: "Break", value: "break", color: "#ff3b30" },
      { name: "Regular Goal", value: "regular_goal", color: "#36B05F" },
      { name: "First Half Extra Time", value: "first_half_extra_time", color: "#ff3b30" },
      { name: "Comment", value: "comment", color: "#DEA742" },
      { name: "Penalty", value: "penalty", color: "#429ADE" },
      { name: "Penalty Awarded", value: "penalty_awarded", color: "#429ADE" },
      { name: "Unknown", value: "unknown", color: "#3636D6" },
      { name: "First Half", value: "first_half", color: "#ff3b30" },
      { name: "Lineup Ready", value: "lineup_ready", color: "#ff3b30" },
      { name: "Red Card", value: "red_card", color: "#E64141" },
      { name: "Second Half", value: "second_half", color: "#ff3b30" },
      { name: "Half Time", value: "half_time", color: "#ff3b30" },
      { name: "Cancelled Goal", value: "cancelled_goal", color: "#E64141" },
    ],
    myGamePlan: [
      { name: "Carry", value: "carry", color: "#DEA742" }, // not present
      { name: "Save", value: "keeper_defensive_action", color: "#DEA742" }, // not present
      { name: "Recovery", value: "recovery", color: "#3636D6" },
      { name: "Pass", value: "pass", color: "#DEA742" },
      { name: "Foul", value: "foul", color: "#E64141" },
      { name: "Clearance", value: "clearance", color: "#429ADE" },
      { name: "Shot", value: "shot", color: "#429ADE" },
      { name: "Duel", value: "duel", color: "#DEA742" }, // not present
      { name: "Interception", value: "interception", color: "#3636D6" },
      { name: "Pressure Action", value: "pressure_action", color: "#DEA742" }, // not present
      { name: "Dribble", value: "dribble", color: "#DEA742" }, // not present
    ],
  },
  volleyball: {
    genius: [
      { name: "Point", value: "point", color: "#36B05F" },
      { name: "Dig", value: "dig", color: "#D636BE" },
      { name: "Block", value: "block", color: "#D636BE" },
      { name: "Set", value: "set", color: "#DEA742" },
      { name: "Reception", value: "reception", color: "#DEA742" },
      { name: "Substitution", value: "substitution", color: "#429ADE" },
      { name: "Attack", value: "attack", color: "#429ADE" },
      { name: "Serve", value: "serve", color: "#429ADE" },
      { name: "Period", value: "period", color: "#ff3b30" },
      { name: "Timeout", value: "timeout", color: "#ff3b30" },
    ],
    volleyStation: [
      { name: "Point", value: "point", color: "#36B05F" },
      { name: "Dig", value: "dig", color: "#D636BE" },
      { name: "Block", value: "block", color: "#D636BE" },
      { name: "Set", value: "set", color: "#DEA742" },
      { name: "Reception", value: "reception", color: "#DEA742" },
      { name: "Substitution", value: "substitution", color: "#429ADE" },
      { name: "Attack", value: "attack", color: "#429ADE" },
      { name: "Serve", value: "serve", color: "#429ADE" },
      { name: "Period", value: "period", color: "#ff3b30" },
      { name: "Timeout", value: "timeout", color: "#ff3b30" },
    ],
  },
  ice_hockey: {
    genius: [
      { name: "Goal", value: "goal", color: "#36B05F" },
      { name: "Save", value: "save", color: "#D636BE" },
      { name: "Block", value: "block", color: "#D636BE" },
      { name: "Faceoff", value: "faceoff", color: "#D636BE" },
      { name: "Assist", value: "assist", color: "#DEA742" },
      { name: "Powerplay", value: "powerplay", color: "#DEA742" },
      { name: "Offside", value: "offside", color: "#E64141" },
      { name: "Substitution", value: "substitution", color: "#429ADE" },
      { name: "Shot", value: "shot", color: "#429ADE" },
      { name: "Penalty", value: "penalty", color: "#429ADE" },
      { name: "Period", value: "period", color: "#ff3b30" },
      { name: "Timeout", value: "timeout", color: "#ff3b30" },
    ],
    olympics: [
      { name: "Advance to phase graphic", value: "advance_to_phase_graphic", color: "#FFD700" },
      { name: "Match graphic", value: "match_graphic", color: "#00CED1" },
      { name: "Close up", value: "close_up", color: "#A9A9A9" },
      { name: "Spectators", value: "spectators", color: "#8A2BE2" },
      { name: "Team list graphic", value: "team_list_graphic", color: "#4682B4" },
      { name: "Previous results graphic", value: "previous_results_graphic", color: "#B0C4DE" },
      { name: "Wide shot", value: "wide_shot", color: "#6A5ACD" },
      { name: "SOG", value: "sog", color: "#DC143C" },
      { name: "OMEGA", value: "omega", color: "#FF4500" },
      { name: "Introduction graphic", value: "introduction_graphic", color: "#32CD32" },
      { name: "Entrance of athletes", value: "entrance_of_athletes", color: "#ADD8E6" },
      { name: "Graphic", value: "graphic", color: "#9ACD32" },
      { name: "Officials", value: "officials", color: "#DDA0DD" },
      { name: "Coach", value: "coach", color: "#FF8C00" },
      { name: "Statistics graphic", value: "statistics_graphic", color: "#7B68EE" },
      { name: "Sport equipment", value: "sport_equipment", color: "#BDB76B" },
      { name: "Referee", value: "referee", color: "#DAA520" },
      { name: "Start of period", value: "start_of_period", color: "#ff3b30" },
      { name: "Faceoff", value: "faceoff", color: "#D636BE" },
      { name: "Overhead shot", value: "overhead_shot", color: "#6495ED" },
      { name: "Shot at goal", value: "shot_at_goal", color: "#429ADE" },
      { name: "Save", value: "save", color: "#D636BE" },
      { name: "Replay", value: "replay", color: "#B22222" },
      { name: "Offside", value: "offside", color: "#E64141" },
      { name: "Score graphic", value: "score_graphic", color: "#20B2AA" },
      { name: "Icing", value: "icing", color: "#E64141" },
      { name: "Minor penalty", value: "minor_penalty", color: "#429ADE" },
      { name: "Goal", value: "goal", color: "#36B05F" },
      { name: "Emotions", value: "emotions", color: "#ff3b30" },
      { name: "End of period", value: "end_of_period", color: "#ff3b30" },
      { name: "Start of highlights", value: "start_of_highlights", color: "#FF69B4" },
      { name: "Highlight package", value: "highlight_package", color: "#FF1493" },
      { name: "Specialty camera", value: "specialty_camera", color: "#800080" },
      { name: "Analytics", value: "analytics", color: "#008B8B" },
      { name: "Multi-cam", value: "multi-cam", color: "#4B0082" },
      { name: "End of highlights", value: "end_of_highlights", color: "#C71585" },
      { name: "Sounds", value: "sounds", color: "#D3D3D3" },
      { name: "Time out", value: "time_out", color: "#ff3b30" },
      { name: "Winner", value: "winner", color: "#FFD700" },
      { name: "Flags", value: "flags", color: "#FF00FF" },
      { name: "Result graphic", value: "result_graphic", color: "#00FA9A" },
      { name: "Match results graphic", value: "match_results_graphic", color: "#2E8B57" },
      { name: "Final rank graphic", value: "final_rank_graphic", color: "#8B008B" },
      { name: "Start of sport clip", value: "start_of_sport_clip", color: "#87CEEB" },
      { name: "End of sport clip", value: "end_of_sport_clip", color: "#4682B4" },
      { name: "Start of montage", value: "start_of_montage", color: "#DB7093" },
      { name: "Montage package", value: "montage_package", color: "#CD5C5C" },
      { name: "End of montage", value: "end_of_montage", color: "#BC8F8F" },
      { name: "Gold medal", value: "gold_medal", color: "#FFD700" },
      { name: "Silver medal", value: "silver_medal", color: "#C0C0C0" },
      { name: "Presenter", value: "presenter", color: "#DA70D6" },
      { name: "Injury", value: "injury", color: "#FF6347" },
    ],
    tv2: [
      { name: "Clock Start", value: "clock_start", color: "#2dd24e" },
      { name: "Comment", value: "comment", color: "#DEA742" },
      { name: "Clock Stop", value: "clock_stop", color: "#ff3b30" },
      { name: "Face Off", value: "face_off", color: "#8e87c5" },
      { name: "Clock Update", value: "clock_update", color: "#ff3b30" },
      { name: "Period End", value: "period_end", color: "#ff3b30" },
      { name: "Event End", value: "event_end", color: "#ff3b30" },
      { name: "Period Start", value: "period_start", color: "#87c591" },
      { name: "Two Min Suspension", value: "two_min_suspension", color: "#E64141" },
      { name: "Regular Goal", value: "regular_goal", color: "#36B05F" },
      { name: "Prelim Period End", value: "prelim_period_end", color: "#ff3b30" },
      { name: "Power Play Goal", value: "power_play_goal", color: "#DEA742" },
      { name: "Event Start", value: "event_start", color: "#c187c5" },
      { name: "Prelim Event End", value: "prelim_event_end", color: "#ff3b30" },
    ],
  },
  handball: {
    tv2: [
      { name: "Regular Goal", value: "regular_goal", color: "#36B05F" },
      { name: "Missed Shot", value: "missed_shot", color: "#DEA742" },
      { name: "Yellow Card", value: "yellow_card", color: "#DEA742" },
      { name: "Unknown", value: "unknown", color: "#E64141" },
      { name: "Penalty Awarded", value: "penalty_awarded", color: "#E64141" },
      { name: "Two Minute Suspension", value: "two_min_suspension", color: "#E64141" },
      { name: "Missed Penalty", value: "missed_penalty", color: "#E64141" },
      { name: "Red Card", value: "red_card", color: "#E64141" },
      { name: "Technical Fault", value: "technical_fault", color: "#E64141" },
      { name: "Substitution Goalkeeper In", value: "substitution_goalkeeper_in", color: "#429ADE" },
      { name: "Substitution Goalkeeper Out", value: "substitution_goalkeeper_out", color: "#429ADE" },
      { name: "Penalty", value: "penalty", color: "#429ADE" },
      { name: "Event Start", value: "event_start", color: "#ff3b30" },
      { name: "Event End", value: "event_end", color: "#ff3b30" },
      { name: "First Half", value: "first_half", color: "#ff3b30" },
      { name: "Second Half", value: "second_half", color: "#ff3b30" },
      { name: "Half Time", value: "half_time", color: "#ff3b30" },
      { name: "Full Time", value: "full_time", color: "#ff3b30" },
      { name: "Clock Start", value: "clock_start", color: "#ff3b30" },
      { name: "Clock Stop", value: "clock_stop", color: "#ff3b30" },
      { name: "Clock Update", value: "clock_update", color: "#ff3b30" },
      { name: "Period Start", value: "period_start", color: "#ff3b30" },
      { name: "Period End", value: "period_end", color: "#ff3b30" },
      { name: "Timeout", value: "timeout", color: "#ff3b30" },
    ],
    sportRadar: [
      { name: "Match Started", value: "match_started", color: "#ff3b30" },
      { name: "Match Ended", value: "match_ended", color: "#E64141" },
      { name: "Period Start", value: "period_start", color: "#ff3b30" },
      { name: "Period Score", value: "period_score", color: "#DEA742" },
      { name: "Score Change", value: "score_change", color: "#36B05F" },
      { name: "Substitution", value: "substitution", color: "#429ADE" },
      { name: "Shot On Target", value: "shot_on_target", color: "#429ADE" },
      { name: "Shot Off Target", value: "shot_off_target", color: "#429ADE" },
      { name: "Yellow Card", value: "yellow_card", color: "#DEA742" },
      { name: "Blue Card", value: "blue_card", color: "#3636D6" },
      { name: "Red Card", value: "red_card", color: "#E64141" },
      { name: "Save", value: "save", color: "#D636BE" },
      { name: "Penalty Missed", value: "penalty_missed", color: "#E64141" },
      { name: "Break Start", value: "break_start", color: "#3636D6" },
      { name: "Shot Saved", value: "shot_saved", color: "#DEA742" },
      { name: "Seven M Awarded", value: "seven_m_awarded", color: "#429ADE" },
      { name: "Seven M Missed", value: "seven_m_missed", color: "#E64141" },
      { name: "Shot Blocked", value: "shot_blocked", color: "#DEA742" },
      { name: "Suspension", value: "suspension", color: "#E64141" },
      { name: "Timeout", value: "timeout", color: "#ff3b30" },
      { name: "Timeout Over", value: "timeout_over", color: "#ff3b30" },
      { name: "Suspension Over", value: "suspension_over", color: "#E64141" },
      { name: "Penalty Shootout", value: "penalty_shootout", color: "#429ADE" },
      { name: "Technical Ball Fault", value: "technical_ball_fault", color: "#E64141" },
      { name: "Technical Rule Fault", value: "technical_rule_fault", color: "#E64141" },
      { name: "Steal", value: "steal", color: "#DEA742" },
      { name: "Empty Net", value: "empty_net", color: "#429ADE" },
    ],
    ringier: [
      { name: "Game Start", value: "game_start", color: "#ff3b30" },
      { name: "Game End", value: "game_end", color: "#E64141" },
      { name: "First Half End", value: "first_half_end", color: "#ff3b30" },
      { name: "Second Half Start", value: "second_half_start", color: "#ff3b30" },
      { name: "Goal", value: "goal", color: "#36B05F" },
      { name: "Penalty", value: "penalty", color: "#429ADE" },
      { name: "Yellow Card", value: "yellow", color: "#DEA742" },
      { name: "Two Minute Suspension", value: "two_minute_suspension", color: "#E64141" },
    ],
  },
  tennis: {
    sportMedia: [
      { name: "Point", value: "point", color: "#36B05F" },
      { name: "Serve", value: "serve", color: "#429ADE" },
      { name: "Ace", value: "ace", color: "#429ADE" },
      { name: "Fault", value: "fault", color: "#E64141" },
    ],
  },
  "Moto Racing": {
    nascar: [
      { name: "Pit Stop", value: "pit_stop", color: "#36B05F" },
      { name: "Overtake", value: "overtake", color: "#D636BE" },
      { name: "Flag Start", value: "flag_start", color: "#DEA742" },
      { name: "Flag Caution", value: "flag_caution", color: "#DEA742" },
      { name: "Flag Finish", value: "flag_finish", color: "#DEA742" },
      { name: "Flag Restart", value: "flag_restart", color: "#DEA742" },
      { name: "Flag", value: "flag", color: "#36B05F" },
      { name: "Flag Red", value: "flag_red", color: "#FFFFFF" },
      { name: "Lap Lead", value: "lap_lead", color: "#D636BE" },
      { name: "Pass", value: "pass", color: "#D636BE" },
      { name: "Last 10 Lap Lead", value: "last_10_lap_lead", color: "#D636BE" },
      { name: "Last Stage Lap Lead", value: "last_stage_lap_lead", color: "#D636BE" },
      { name: "Last Lap Lead", value: "last_lap_lead", color: "#D636BE" },
    ],
  },
  curling: {
    olympics: [
      { name: "Throw", value: "Throw", color: "#dfcf23dd" },
      { name: "Emotion", value: "Emotions", color: "#D636BE" },
      { name: "Replay", value: "Replay", color: "#1374beff" },
      { name: "Takeout", value: "Takeout", color: "#b9852695" },
      { name: "Draw", value: "Draw", color: "#4ed636ff" },
      { name: "Graphics", value: "graphic", color: "#d4c6e1ff" },
      { name: "Overhead Shot", value: "Overhead shot", color: "#429ADE" },
      { name: "Wide Shot", value: "Wide shot", color: "#d75757ff" },
      { name: "Finish", value: "Finish", color: "#f90ff9ff" },
    ],
  },
  basketball: {
    genius: [
      { name: "2 Pointer", value: "2pt", color: "#36B05F" },
      { name: "3 Pointer", value: "3pt", color: "#36B05F" },
      { name: "Block", value: "block", color: "#D636BE" },
      { name: "Steal", value: "steal", color: "#D636BE" },
      { name: "Turnover", value: "turnover", color: "#D636BE" },
      { name: "Rebound", value: "rebound", color: "#DEA742" },
      { name: "Assist", value: "assist", color: "#DEA742" },
      { name: "Comment", value: "comment", color: "#DEA742" },
      { name: "Free Throw", value: "freethrow", color: "#429ADE" },
      { name: "Substitution", value: "substitution", color: "#429ADE" },
      { name: "Foul", value: "foul", color: "#E64141" },
      { name: "Timeout", value: "timeout", color: "#ff3b30" },
      { name: "Period", value: "period", color: "#ff3b30" },
      { name: "Jumpball", value: "jumpball", color: "#DEA742" },
      { name: "Foul on", value: "foulon", color: "#E64141" },
      { name: "Clock", value: "clock", color: "#429ADE" },
      { name: "Participated", value: "participated", color: "#429ADE" },
      { name: "Head Coach Challenge", value: "headcoachchallenge", color: "#DEA742" },
      { name: "Game", value: "game", color: "#36B05F" },
    ],
    cbs: [
      { name: "2 Pointer", value: "2pt", color: "#36B05F" },
      { name: "3 Pointer", value: "3pt", color: "#36B05F" },
      { name: "Block", value: "block", color: "#D636BE" },
      { name: "Steal", value: "steal", color: "#D636BE" },
      { name: "Turnover", value: "turnover", color: "#D636BE" },
      { name: "Rebound", value: "rebound", color: "#DEA742" },
      { name: "Assist", value: "assist", color: "#DEA742" },
      { name: "Comment", value: "comment", color: "#DEA742" },
      { name: "Free Throw", value: "freethrow", color: "#429ADE" },
      { name: "Substitution", value: "substitution", color: "#429ADE" },
      { name: "Foul", value: "foul", color: "#E64141" },
      { name: "Timeout", value: "timeout", color: "#ff3b30" },
      { name: "Period", value: "period", color: "#ff3b30" },
      { name: "Jumpball", value: "jumpball", color: "#DEA742" },
      { name: "Game", value: "game", color: "#36B05F" },
    ],
  },
  "American Football": {
    cbs: [
      { name: "Rush", value: "Rush", color: "#36B05F" },
      { name: "Complete Pass", value: "CompletePass", color: "#36B05F" },
      { name: "Fair Catch", value: "FairCatch", color: "#36B05F" },
      { name: "Penalty", value: "Penalty", color: "#DEA742" },
      { name: "Sack", value: "Sack", color: "#DEA742" },
      { name: "Punt", value: "Punt", color: "#DEA742" },
      { name: "Incomplete Pass", value: "IncompletePass", color: "#DEA742" },
      { name: "Field Goal", value: "FieldGoal", color: "#429ADE" },
      { name: "Kickoff", value: "Kickoff", color: "#429ADE" },
      { name: "Kick Return", value: "KickReturn", color: "#429ADE" },
      { name: "Point After Touchdown", value: "PointAfterTouchdown", color: "#429ADE" },
      { name: "Touchback", value: "Touchback", color: "#429ADE" },
      { name: "Punt Return", value: "PuntReturn", color: "#429ADE" },
      { name: "Fumble Return", value: "FumbleReturn", color: "#429ADE" },
      { name: "Missed Field Goal", value: "MissedFieldGoal", color: "#429ADE" },
      { name: "Interception Return", value: "InterceptionReturn", color: "#429ADE" },
    ],
  },
  korfball: {
    knkv: [
      { name: "Begin First Period", value: "beginfirstperiod", color: "#ff3b30" },
      { name: "End First Period", value: "endfirstperiod", color: "#ff3b30" },
      { name: "Begin Second Period", value: "beginsecondperiod", color: "#ff3b30" },
      { name: "End Second Period", value: "endsecondperiod", color: "#ff3b30" },
      { name: "Highlight", value: "highlight", color: "#DEA742" },
      { name: "Goal Long Shot", value: "goallongshot", color: "#36B05F" },
      { name: "Goal Midrange Shot", value: "goalmidrangeshot", color: "#36B05F" },
      { name: "Goal Near Shot", value: "goalnearshot", color: "#36B05F" },
      { name: "Goal Running In Shot", value: "goalrunninginshot", color: "#36B05F" },
      { name: "Goal Free Pass", value: "goalfreepass", color: "#36B05F" },
      { name: "Goal Penalty", value: "goalpenalty", color: "#36B05F" },
      { name: "Missed Penalty", value: "missedpenalty", color: "#D636BE" },
      { name: "Red Card", value: "redcard", color: "#E64141" },
      { name: "Yellow Card", value: "yellowcard", color: "#DEA742" },
      { name: "Treatment", value: "treatment", color: "#E64141" },
      { name: "Shot Clock Violation", value: "shotclockviolation", color: "#E64141" },
      { name: "Timeout", value: "timeout", color: "#429ADE" },
      { name: "Undo goal", value: "undogoal", color: "#429ADE" },
      { name: "Ball To Other Area", value: "balltootherarea", color: "#429ADE" },
      { name: "Substitute", value: "substitute", color: "#429ADE" },
    ],
  },
  golf: {
    smt: [
      { name: "Stroke", value: "stroke", color: "#429ADE" },
      { name: "Hole In One", value: "hole_in_one", color: "#FFD700" },
      { name: "Albatross", value: "albatross", color: "#1A3FB0" },
      { name: "Eagle", value: "eagle", color: "#2563EB" },
      { name: "Birdie", value: "birdie", color: "#4A90D9" },
      { name: "Par", value: "par", color: "#36B05F" },
      { name: "Bogey", value: "bogey", color: "#E74C3C" },
      { name: "Double Bogey", value: "double_bogey", color: "#E74C3C" },
      { name: "Triple Bogey", value: "triple_bogey", color: "#C0392B" },
    ],
  },
};

const statsPerformFootballDefaultEvents = [
  "goal",
  "start",
  "end",
  "card",
  "save",
  "miss",
  "post",
  "contentiousrefereedecision",
];

const metatagsEventFiltersBasedOnCategory = {
  cricket: ["Four", "Six", "Wicket"],
  basketball: ["Made 2 Pointer", "Made 3 Pointer"],
};

const metatagsPlayersAllowedCategories = ["cricket", "football", "American Football"];

const metatagsTextFields = {
  cricket: ["run", "wicket"],
  football: ["score"],
};

const jwplayerId = {
  trimClipModal: "jwplayerTrimClipModal",
  clipCDTeamCustomEditModal: "jwplayerClipCDTeamCustomEditModal",
  downloadMatchModal: "jwplayerDownloadMatchModal",
  trimSectionPublishModal: "jwplayerTrimSectionPublishModal",
  segmentSideBar: "jwplayerSegmentSideBar",
  tournamentScoreboard: "jwplayerTournamentScoreboard",
};

const videojsId = {
  trimClipModal: "videojsTrimClipModal",
  clipCDTeamCustomEditModal: "videojsClipCDTeamCustomEditModal",
  downloadMatchModal: "videojsDownloadMatchModal",
  trimSectionPublishModal: "videojsTrimSectionPublishModal",
  segmentSideBar: "videojsSegmentSideBar",
  tournamentScoreboard: "videojsTournamentScoreboard",
  videoPlayer: "videojsVideoPlayer",
  liveVideo: "JwPlayer",
  liveVideoSidePlayer: "JwPlayer2",
};

const templateDimension = {
  width: 1920,
  height: 1080,
};

const advanceConfig = [
  {
    label: "Segments",
    value: "SEGMENTS",
  },
  {
    label: "Manifest",
    value: "MANIFEST",
  },
];

export {
  acceptedFilesSize,
  advanceConfig,
  allowAspectRatio,
  aspect_ratio,
  aspectRatio,
  aspectRatioClip,
  aspectRatios,
  aspectRatioVal,
  audioOptions,
  audios,
  // autoFlipAndCenterCropCategories,
  autoFlipCategories,
  awsRegions,
  awsRegionsWithValues,
  bitRateModes,
  bumpers,
  clientPermissions,
  clipRating,
  cookieExpiry,
  dashboardFilter,
  dashoboardMenu,
  datafeedPointerCategories,
  deviceArray,
  dolbyAudio51RemixOptions,
  downloadTemplates,
  downloadTemplatesYoutube,
  editFields,
  entertainment_fields,
  fileTypes,
  fillMultiAudioWithStreamOptions,
  fpsModes,
  frequencyArr,
  ftpChannelLanguage,
  gameTime,
  gameTimeBasketBall,
  graphics,
  heartbeat,
  jwplayerId,
  languageArr,
  matchType,
  MEDIA_STATIC_INPUT_TYPE,
  mediaLiveInput,
  mediaLiveTemplateOption,
  mediaLiveTemplateRegions,
  mediaStaticInput,
  metatagsEventFiltersBasedOnCategory,
  metatagsPlayersAllowedCategories,
  metatagsTextFields,
  months,
  numberFormat,
  options,
  platformLimit,
  playbackLabels,
  playbackList,
  playBackSpeed,
  publishElement,
  runObject,
  scoreboardOcrEventItems,
  settingsRecordsPerPage,
  shotType,
  socialMediaLabels,
  sonyClientPublishField,
  sportTags,
  staticDimension,
  statsPerformFootballDefaultEvents,
  steps,
  storyInputFields,
  streamingType,
  streamPointerDeleteableTypes,
  streamPointerEditableTypes,
  streamPointerItems,
  streamPointerSource,
  streamPointerSourceLabels,
  tagValues,
  templateDimension,
  timelineZoomValues,
  videojsId,
};

export const cookies = [
  {
    title: "Necessary",
    description:
      "Necessary cookies are required to enable the basic features of this site, such as providing secure log-in or adjusting your consent preferences. These cookies do not store any personally identifiable data.",
    tag: "Always Active",
  },
  {
    title: "Functional",
    description:
      "Functional cookies help perform certain functionalities like sharing the content of the website on social media platforms. collecting feedback, and other third-party features.",
    checkbox: true,
    default: true,
  },
  {
    title: "Analytics",
    description:
      "Analytical cookies are used to understand how visitors interact with the websites. Those cookies help provide information on metrics such as the number of visitors, bounce rate, traffic source, etc",
    checkbox: true,
    default: true,
  },
  {
    title: "Performance",
    description:
      "Performance cookies are used to understand and analyze the key performance indexes of the website which helps in delivering a better user experience for the visitors.",
    tag: "Always Active",
  },
  {
    title: "Others",
    description:
      "Other uncategorized cookies are those that are being analyzed and have not been classified into a category as yet",
    checkbox: true,
  },
];
